import { PortalTextareaField } from 'components/FormControls';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { IArticleComment } from 'models/magazine/article/articlecomment';
import { IEditArticleCommentAction } from 'models/magazine/article/editarticlecomment';
import React = require('react');
import { connect } from 'react-redux';
import { IStore } from 'redux/IStore';
import { useOutsideAlerter } from './ArticleComment';
import * as c from 'models/constants';
import { IArticleCommentBox } from 'models/common';
import { resetData, submitUpdateArticleComment } from 'redux/modules/magazine/article/editarticlecomment';

interface EditCommentProps extends InjectedFormProps {
	comment: IArticleComment;
	t?: (key: string) => string;
	toggleEdit?: () => void;
	handleSubmit?: any;
	submitUpdateArticleComment: (comment: IArticleComment) => IEditArticleCommentAction;
}

const EditArticleCommentForm = (props: EditCommentProps) => {
	const { comment, toggleEdit, submitUpdateArticleComment, t } = props;
	const [commentBody, setCommentBody] = React.useState(comment.body);
	const editFormRef = React.useRef<HTMLFormElement>(null);

	useOutsideAlerter(editFormRef, toggleEdit, false); // close edit form when clicking outside (same as clicking cancel)

	const editComment = () => {
		const editedComment: IArticleComment = {
			...comment,
			body: commentBody,
			articleId: comment?.articleId,
		};

		submitUpdateArticleComment(editedComment);
		toggleEdit();
	};

	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { value } = e.target;
		setCommentBody(value);
	};

	const onEnterPress = (e) => {
		// submit form on enter
		if (e.keyCode == 13 && e.shiftKey == false) {
			e.preventDefault();
			if (e.target.value.length > 0) {
				editFormRef.current.requestSubmit();
			}
		}
	};

	return (
		<form autoComplete="off" onSubmit={props.handleSubmit(editComment)} ref={editFormRef}>
			<div className="editCommentContainer">
				<Field
					name="articleComment.body"
					component={PortalTextareaField}
					input={{ value: commentBody }}
					type="text"
					label={t('ArticleCommentItemCard_Comment')}
					autoFocus={true}
					onChangeAction={handleChange}
					rows={3}
					height={'auto'}
					onKeyDownAction={onEnterPress}
				/>
				<div className="editCommentSubmit">
					<button onClick={() => toggleEdit()}>{t('BSPortal_Common_Cancel')}</button>
					<button type="submit">{t('BSPortal_Common_Confirm')}</button>
				</div>
			</div>
		</form>
	);
};

const mapStateToProps = (state: IStore) => {
	let currentFormValues: IArticleCommentBox = null;

	if (state.form[c.FORM_NAME_EDIT_ARTICLE_COMMENT] && state.form[c.FORM_NAME_EDIT_ARTICLE_COMMENT].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_ARTICLE_COMMENT].values;
	}

	return {
		currentFormValues,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitUpdateArticleComment: (comment: IArticleComment) => dispatch(submitUpdateArticleComment(comment)),
		resetData: () => dispatch(resetData()),
	};
};

let EditArticleComment = reduxForm<{}, EditCommentProps>({
	form: c.FORM_NAME_EDIT_ARTICLE_COMMENT,
	enableReinitialize: true,
})(EditArticleCommentForm);

EditArticleComment = connect(mapStateToProps, mapDispatchToProps)(EditArticleComment);

export default EditArticleComment;
